import { gql } from "@apollo/client";

export const GET_DOCUMENTO_CREDITICIA = gql`
    query DocumentByEvaluacionId($IdEvaluacion: Int!){
        documentByEvaluacionId(idEvaluacionInput : $IdEvaluacion){
            titulo
            archivo
            contentType    
            extension
            idEvaluacion 
        }
    }
`;